import React from 'react';
import { View, Text } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Focusable } from '../../Focusable';
import { Icon } from '../../Icon';
export const Request = ({ onRequest, style, fluid, type }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: [styles.container, fluid ? styles.fluid : null, style], hoverStyle: styles.hover, onPress: onRequest }, ({ hovered }) => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: [styles.circle, hovered ? styles.hoveredCircle : {}] },
            React.createElement(Icon, { name: 'add', size: 23, color: (color) => hovered ? color.primary.solidHover : color.primary.solid })),
        React.createElement(Text, { style: [styles.text, hovered ? styles.hoveredText : {}] }, type === 'regular' ? `Request a New\nTutor` : `Get instant\nhelp`)))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        borderRadius: size.G,
        alignItems: 'center',
        borderWidth: size.A,
        borderStyle: 'dashed',
        borderColor: color.invert2.p4,
        justifyContent: 'center',
        padding: size.G - size.A
    },
    fluid: { flex: 1 },
    hover: { borderColor: color.primary.ghost },
    circle: {
        padding: size.G,
        borderRadius: 9999,
        backgroundColor: color.primary.ghost
    },
    hoveredCircle: { backgroundColor: color.primary.ghostHover },
    text: {
        color: color.primary.solid,
        textAlign: 'center',
        fontSize: 15,
        lineHeight: 19,
        fontWeight: '600',
        marginTop: size.C,
        width: 110
    },
    hoveredText: { color: color.primary.solidHover }
}));
//# sourceMappingURL=Request.js.map